import styled from 'styled-components'

export const ContainerPage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    
`

ContainerPage.Content = styled.div`
    max-width: 1880px;
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-top: 65px;
    margin-bottom: 100px;
    
    @media (max-width <= 1366px) {
        width: calc(100% - 40px);
        max-width: 1220px !important;
    }    
`

ContainerPage.Menu = styled.div`
    padding: 0rem 0;
    width: 220px;
    flex-shrink: 0;
    position: static;
    background: transparent;
    opacity: 1;
    visibility: visible;
    margin-right: 10px;
    border: none;
    transform: none;
    max-height: none;
    min-height: none;

    @media (max-width: 993px) {
        display: none;
    }
`

ContainerPage.ContentPage = styled.div`
    padding: 0rem 0;
    margin-right: 10px;
    width: calc(100% - 220px);

    @media (max-width: 993px) {
        width: 100%;
    }
`
